import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './ExpandCell.css';

export interface ExpandCellProps {
    isExpanded: boolean;
    onExpandClick: () => void;
}

export class ExpandCell extends React.PureComponent<ExpandCellProps, {}> {
    render() {
        return <div className={classNames(Bem.cls('expand-cell'))}>{this.getExpand()}</div>;
    }

    private getExpand = (): React.ReactNode => {
        const { isExpanded, onExpandClick } = this.props;

        return (
            <div>
                <div className={Bem.cls('expand-cell', 'button-wrapper')}>
                    <ButtonDecorator
                        theme={'clear'}
                        size={'n'}
                        onClick={onExpandClick}
                        cls={classNames(
                            Bem.cls('expand-cell', 'expand-btn'),
                            isExpanded
                                ? Bem.cls('expand-cell', 'expand-btn-up')
                                : Bem.cls('expand-cell', 'expand-btn-down')
                        )}
                    >
                        <Shape2
                            cls={Bem.cls('expand-cell', 'expand-shape', {
                                rotate: isExpanded ? 'up' : 'down'
                            })}
                            icon={Shape2Icon.verticalArrow}
                            width={12}
                            height={12}
                        />
                    </ButtonDecorator>
                </div>
            </div>
        );
    };
}
